(function () {
  'use strict';

  var preloader = document.getElementById('ss-page-preloader');
  if (!preloader) return;

  var pageReady = document.readyState === 'interactive' || document.readyState === 'complete';
  var pendingRequests = 0;
  var hideTimer;

  function show() {
    window.clearTimeout(hideTimer);
    preloader.classList.remove('is-hidden');
    preloader.removeAttribute('hidden');
  }

  function hide() {
    if (!pageReady || pendingRequests > 0) return;

    preloader.classList.add('is-hidden');
    hideTimer = window.setTimeout(function () {
      preloader.setAttribute('hidden', 'hidden');
    }, 450);
  }

  function isShopifyApiRequest(input) {
    var url = typeof input === 'string' ? input : input && input.url;
    return url && /\/(?:cart\/(?:add|change|update|clear)|recommendations\/products|search\/suggest)(?:\.js|\.json|\/)?(?:\?|$)/i.test(url);
  }

  function trackRequest(promise) {
    pendingRequests += 1;
    show();
    return promise.finally(function () {
      pendingRequests = Math.max(0, pendingRequests - 1);
      hide();
    });
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var request = nativeFetch.call(this, input, init);
      return isShopifyApiRequest(input) ? trackRequest(request) : request;
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    pageReady = true;
    hide();
  });

  if (pageReady) hide();
})();
